module.exports = __webpack_public_path__ + "static/media/deleted-icon.a27456b0.svg";